import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorId}/conversion-metrics/firm-overview';

type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

const getConversionMetricsFirmOverview = async ({ creatorId }: ThisApi['params']): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getConversionMetricsFirmOverview;
